import { defineComponent as _defineComponent } from 'vue'
import LayoutA from 'JS/dxp/components/shared/story-item-carousels/LayoutA.vue';
import LayoutB from 'JS/dxp/components/shared/story-item-carousels/LayoutB.vue';
import LayoutC from 'JS/dxp/components/shared/story-item-carousels/LayoutC.vue';
import StoryCarouselWidgetStory from './StoryCarouselWidgetStory.vue';
import { computed } from 'vue';
import { createPromoDataAttributes } from 'JS/utilities/analytics';
import { getStoryOrItemCarouselLink } from 'JS/dxp/types/widgets/computed';
import { StoryAndItemCarouselLayout } from 'JS/dxp/types/widgets/shared';
import { StoryCarouselStory, StoryCarouselWidgetResource } from 'JS/dxp/types/widgets/story-carousel-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'StoryCarouselWidget',
  props: {
    widget: null
  },
  setup(__props: any) {

const props = __props as {
	widget: StoryCarouselWidgetResource;
}



const layoutComponent = computed(() => {
	switch (props.widget.widget.layout) {
		case StoryAndItemCarouselLayout.A:
			return LayoutA;
		case StoryAndItemCarouselLayout.B:
			return LayoutB;
		case StoryAndItemCarouselLayout.C:
			return LayoutC;
		default:
			return null;
	}
});

const link = computed(() => getStoryOrItemCarouselLink(props.widget.widget));

const layoutPromoDataAttrs = computed(() => {
	const { title, linkText, linkUrl, layout } = props.widget.widget;
	if (!linkText || !linkUrl) {
		return null;
	}

	return createPromoDataAttributes({
		promoId: linkUrl.replace('https://www.farmandfleet.com', ''),
		promoName: title,
		creativeSlot: 'dxp_story_carousel_0',
		creativeName: `dxp_story_carousel_${StoryAndItemCarouselLayout[layout]}`,
	});
});

function createStoryPromoAttributes(story: StoryCarouselStory, index: number) {
	return createPromoDataAttributes({
		promoId: story.link.replace('https://www.farmandfleet.com', ''),
		promoName: story.title,
		creativeSlot: `dxp_story_carousel_${index + 1}`,
		creativeName: `dxp_story_carousel_${StoryAndItemCarouselLayout[props.widget.widget.layout]}_story`,
	});
}


return { __sfc: true,props, layoutComponent, link, layoutPromoDataAttrs, createStoryPromoAttributes, StoryCarouselWidgetStory }
}

})